import { OrganOnOCSDeclineReason } from '@/api/apis/case';

export const LOG_RECORDS_PROPERTY_ORDER: Record<string, number> = {
  RecipientHospitalDate: 0,
  RecipientHospitalTime: 1,
  RecipientHospitalTimeZone: 2,
  RecipientHospitalORChangeReason: 3,
};

// Groups each donor data parameter with its related "Details" field, following the order of the
// Unallocated Clinical Request form (see forms/DonorProfileForm) so the case log reads the same way.
export const DONOR_DATA_LOG_RECORDS_PROPERTY_ORDER: Record<string, number> = {
  'DonorDemographics.Age': 0,
  'DonorDemographics.Gender': 1,
  'DonorDemographics.Height': 2,
  'DonorDemographics.Weight': 3,
  'DonorDemographics.CauseOfDeath': 4,
  'DonorParameters.NeuroStatus': 5,
  'DonorParameters.Vasopressors': 6,
  'DonorParameters.VasopressorsDetails': 7,
  'DonorParameters.SustainedHypotension': 8,
  'DonorParameters.SustainedHypotensionDetails': 9,
  'DonorBlood.ABO': 10,
  'DonorBlood.PositiveSerologies': 11,
  ReasonForUnallocated: 12,
  'LiverData.TotalBilirubinRecentResult1': 13,
  'LiverData.TotalBilirubinRecentResult2': 14,
  'LiverData.AspartateAminotransferaseRecentResult1': 15,
  'LiverData.AspartateAminotransferaseRecentResult2': 16,
  'LiverData.AlanineAminotransferaseRecentResult1': 17,
  'LiverData.AlanineAminotransferaseRecentResult2': 18,
  'LiverData.CtScan': 19,
  'LiverData.CtScanDetails': 20,
  'LiverData.CtScanLink': 21,
  'LiverData.CtScanDocuments': 22,
  'LiverData.WillLocalSurgeonPerformOrganProcurement': 23,
  'LiverData.LocalSurgeonToProcureDetails': 24,
  'LiverData.Sedation': 25,
  'LungData.MatchRunOcsCenterNames': 26,
  'LungData.MostRecentPfRatio': 27,
  'LungData.NetFluidBalanceOverPast24Hours': 28,
  'LungData.CultureSensitivityResults': 29,
  'LungData.CtScan': 30,
  'LungData.CtScanDetails': 31,
  'LungData.CtScanLink': 32,
  'LungData.CtScanDocuments': 33,
  'LungData.Sedation': 34,
  'HeartData.MatchRunOcsCenterNames': 35,
};

export const ORGAN_DECLINED_TEXTS: Record<OrganOnOCSDeclineReason, string> = {
  [OrganOnOCSDeclineReason.DonorQuality]: 'Donor quality.',
  [OrganOnOCSDeclineReason.OrganNotViable]: 'Organ not viable.',
  [OrganOnOCSDeclineReason.RecipientReasons]: 'Recipient reasons.',
  [OrganOnOCSDeclineReason.LogisticalIssues]: 'Logistical issues.',
  [OrganOnOCSDeclineReason.TXCenterAcceptanceCriteria]: 'TX Center acceptance criteria.',
  [OrganOnOCSDeclineReason.AlternatePreservationMethod]: 'Alternate preservation method.',
};
